export const setPageTitle = (title: string) => {
  if (title) document.title = title
}
